import axios from "axios";
import { IReceipt, ISearchReceipt } from "../../models/WareHouseModel";
import { PaginateModel } from "../../models/PaginateModel";
import { ADMIN_RECEIPT_ENDPOINT } from "../../constants/endpoints";
import { ResponseModel } from "../../models/ResponseModel";
import { ReceiptDetailModel, ReceiptDetailSearchModel } from "../../models/ReceiptDetailModel";
import { IAxiosSuccess } from "../../models/AxiosModel";
export interface PdListModel {
  paginate_data: PaginateModel<ReceiptDetailModel>,
  sub_total: number
}

export function searchProduct(params: ReceiptDetailSearchModel) {
  return axios.get<PdListModel>(`${ADMIN_RECEIPT_ENDPOINT}/find-receipt-consign-product`, {params})
}

export function exportSearchProduct(params: ReceiptDetailSearchModel) {
  return axios.get(`${ADMIN_RECEIPT_ENDPOINT}/export-consign-product-search`, {params, responseType: 'blob'})
}

export function importReceipt(formData: FormData) {
  return axios.post<IAxiosSuccess>(`${ADMIN_RECEIPT_ENDPOINT}/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}